import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Home.css'; // Import CSS for styling

const Home = () => {
    const [files, setFiles] = useState([]);
    const [newFolderName, setNewFolderName] = useState('');
    const [folderStructure, setFolderStructure] = useState([]);
    const [selectedFolder, setSelectedFolder] = useState(null);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    const handleFileUpload = (event) => {
        const uploadedFiles = event.target.files;
        if (selectedFolder) {
            selectedFolder.children = [...selectedFolder.children, ...Array.from(uploadedFiles).map(file => ({ name: file.name, type: 'file' }))];
            setFolderStructure([...folderStructure]);
        } else {
            setFiles([...files, ...Array.from(uploadedFiles)]);
        }
    };

    const handleFolderCreation = (parentFolder = null) => {
        if (newFolderName.trim()) {
            const newFolder = { name: newFolderName, type: 'folder', children: [], expanded: false };
            if (parentFolder) {
                parentFolder.children.push(newFolder);
                setFolderStructure([...folderStructure]);
            } else {
                setFolderStructure([...folderStructure, newFolder]);
            }
            setNewFolderName('');
        }
    };

    const handleFolderActions = (action, folder) => {
        switch (action) {
            case 'rename':
                const newName = prompt("Enter new name:", folder.name);
                if (newName) {
                    folder.name = newName;
                    setFolderStructure([...folderStructure]);
                }
                break;
            case 'delete':
                const deleteFolder = (folders, targetFolder) => {
                    return folders.filter(f => f !== targetFolder).map(f => {
                        if (f.children) {
                            f.children = deleteFolder(f.children, targetFolder);
                        }
                        return f;
                    });
                };
                setFolderStructure(deleteFolder(folderStructure, folder));
                break;
            default:
                break;
        }
    };

    const renderFolderTree = (folders) => {
        return folders.map((folder, index) => (
            <li key={index} onContextMenu={(e) => e.preventDefault()}>
                <span onClick={() => folder.expanded = !folder.expanded}>
                    {folder.expanded ? '📂' : '📁'} {folder.name}
                </span>
                <div className="folder-actions">
                    <button onClick={() => handleFolderActions('rename', folder)}>Rename</button>
                    <button onClick={() => handleFolderActions('delete', folder)}>Delete</button>
                </div>
                {folder.expanded && (
                    <ul>
                        {renderFolderTree(folder.children)}
                        <li>
                            <input
                                type="text"
                                value={newFolderName}
                                onChange={(e) => setNewFolderName(e.target.value)}
                                placeholder="New Subfolder Name"
                            />
                            <button onClick={() => handleFolderCreation(folder)}>Create Subfolder</button>
                        </li>
                    </ul>
                )}
            </li>
        ));
    };

    return (
        <div className="home-container">
            <h1>Welcome to DSAD AF cloud storage system</h1>
            <div className="login-status">
                {isLoggedIn ? "Logged in" : "You are not signed in"}
            </div>
            <nav>
                <ul className="nav-links">
                    <li><Link to="/login">Login</Link></li>
                    <li><Link to="/register">Register</Link></li>
                    <li><Link to="/user">User</Link></li>
                    <li><Link to="/about">About</Link></li>
                </ul>
            </nav>
            <div className="storage-features">
                <h2>File Storage Features</h2>
                <div className="file-upload">
                    <label htmlFor="file-upload" className="custom-file-upload">
                        Choose Files
                    </label>
                    <input
                        id="file-upload"
                        type="file"
                        multiple
                        onChange={handleFileUpload}
                    />
                    <button onClick={() => alert("First you should log in to the DSADAF App")}>
                        Upload Files
                    </button>
                </div>
                <div className="folder-creation">
                    <input
                        type="text"
                        value={newFolderName}
                        onChange={(e) => setNewFolderName(e.target.value)}
                        placeholder="New Folder Name"
                    />
                    <button onClick={() => handleFolderCreation(null)}>Create Folder</button>
                </div>
                <div className="file-list">
                    <h3>Files and Folders</h3>
                    <ul>
                        {renderFolderTree(folderStructure)}
                        {files.map((file, index) => (
                            <li key={index}>
                                📄 {file.name}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Home;
